/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define({
	homePageTitleLabel: 'Kezdőlap',
	myContent: 'Saját tartalom',
	teamContent: 'Csapattartalom',
	folder: 'Mappa',
	files: 'Fájlok',
	actionMenu: 'Műveleti menü',
	myFolder: 'Saját mappák',

	emptyFolderNoContent: 'Nincs tartalom',

	//EmptyStates
	emptyRecentTitle: 'Nem tekintett meg tartalmat a közelmúltban.',
	emptyStateTitle: 'Kezdje adatok hozzáadásával',
	emptyStateBody: 'Kattintson fenti Adatok feltöltése lehetőségre vagy húzzon át ide adatokat a feltöltéshez.',
	emptySearchResultTitle: 'Hmm, a keresés nem hozott eredményt.',
	emptyPortalTitle: 'Nincs portál',
	emptyPortalBody: 'Jelenleg nincsenek portáljai.',
	emptyWsProjectTitle: 'Kezdje egy munkafüzet létrehozásával a Watson Studio alkalmazásban.',
	emptyWsProjectBody: 'Amikor visszatér a Cognos Analytics alkalmazásba, a munkafüzet ott jelenik meg.',
	emptyFilteredResultTitle: 'Hmm, az alkalmazott szűrők nem adtak vissza eredményt.',
	emptyDialogViewTitle: 'Nincs elem',
	removeFromRecents: 'Eltávolítás a legutóbbiak közül',

	// Welcome Banner
	welcomeBannerGreeting: 'Helló. Üdvözli a Cognos Analytics.',
	welcomeBannerDescription: 'A Cognos Analytics mesterséges intelligenciával vezérelt önkiszolgáló elemzéseket biztosít a felhasználók számára. Tekintse meg, hogy az automatizált adatelőkészítés, az adatfeltérképezés és vizuális megjelenítés hogyan vezethet megbízhatóbb döntésekhez.',
	welcomeBannerDescription_trialUser: 'Elkezdheti most azonnal azzal, hogy megtekinti a bemutató videónkat, termékismertetőnket és a Kezdeti lépések lapot.',
	takeTourButtonLabel: 'Termékbemutató megtekintése',
	watchVideoButtonLabel: 'Videó megtekintése',
	// confirmation dialog
	hideWelcomeBannerMsg: 'Biztos benne, hogy kikapcsolja az üdvözlő fejléccsíkot a kezdőlapon? Ezt a Profil és beállítások > Beállítások > Általános oldalon bármikor visszakapcsolhatja. ',
	hideWelcomeBannerTitle: 'Üdvözlő fejléccsík kikapcsolása',
	ok: 'OK',
	cancel: 'Mégse',
	//howto video dialog
	modal_how_title: 'Hogyan... videók',
	modal_overview_title: 'Cognos Analytics bemutatásának megtekintése',
	modal_how_play: 'Videó lejátszása',
	modal_how_video_title_overview: 'Áttekintés',
	modal_how_video_title_getStarted: 'A V11.2 kezdeti lépései',
	modal_how_video_title_newUI: 'Üdvözli az új Cognos élmény',
	modal_how_video_title_dataModule: 'Adatmodulok bemutatása',
	modal_how_video_title_explore: 'Adatok böngészésének bemutatása',
	modal_how_video_title_dashboard: 'Interaktív műszerfalak bemutatása',
	modal_how_video_title_reporting: 'Jelentéskészítés bemutatása',
	modal_how_video_title_mobile: 'A Cognos ereje a tenyerében',

	// Toolbar
	search: 'Keresés',
	addFolder: 'Mappa hozzáadása',
	addLink: 'Hivatkozás hozzáadása',
	filter: 'Szűrő',
	sort: 'Rendezés',
	settings: 'Beállítások',
	tilesView: 'Mozaik nézet',
	listView: 'Listanézet',
	columnView: 'Oszlop nézet',

	// Toolbar Actions
	sortBy: 'Rendezési szempont',
	sortOrder: 'Rendezés',
	name: 'Név',
	modifiedTime: 'Módosítva',
	type: 'Típus',
	ascending: 'Növekvő',
	descending: 'Csökkenő',

	filterType: 'Típus',
	filterModificationTime: 'Módosítva',
	all: 'Mind',
	today: 'Ma',
	yesterday: 'Tegnap',
	pastWeek: 'Múlt hét',
	pastMonth: 'Előző hónap',
	resetFilters: 'Szűrők visszaállítása',

	filterSearchPlaceHolder: 'Szűrés kulcsszavak szerint',

	resetFilterTag: 'Kattintson az X gombra a szűrők alaphelyzetbe állításához.',
	filterTagToolTip: 'Alkalmazott szűrők: %{appliedFilters}.',

	folderName: 'Mappanév',
	addAFolder: 'Mappa hozzáadása',
	add: 'Hozzáadás',
	error: 'Hiba',
	newFolderDefaultName: 'Új mappa',
	toastCreateNewFolder: 'A(z) %{nameOfFolder} mappa létrehozásra került a(z) %{tabName} mappában.',
	folderAdded: 'Mappa hozzáadva',
	refresh: 'Frissítés',
	openFolder: 'Mappa megnyitása',

	addAUrl: 'URL hozzáadása',
	linkName: 'URL neve',
	linkNamePlaceholder: 'URL név hozzáadása',
	linkDescription: 'Leírás (nem kötelező)',
	linkDescriptionPlaceholder: 'Leírás hozzáadása',
	linkUri: 'URL cím',
	linkUriPlaceholder: 'Adjon hozzá olyan URL címet egy elfogadható tartománnyal',
	acceptableDomains: 'Elfogadható tartományok',
	viewAcceptableDomains: 'Elfogadható tartományok megtekintése',
	mandatoryField: 'Kötelező mező',
	linkAdded: 'URL hozzáadva',
	toastCreateNewLink: 'A(z) %{nameOfLink} hozzáadásra került a következőhöz: %{tabName}.',
	noEntries: 'Az elfogadható tartományok listája nem tartalmaz bejegyzéseket. Forduljon az adminisztrátorhoz.',

	compact: 'Tömör',
	short: 'Rövid',
	default: 'Alapértelmezett',
	rowSize: 'Sor mérete',

	// GroupyByTypes
	folders: 'Mappák',
	reports: 'Jelentések',
	dashboards: 'Műszerfalak',
	data: 'Adatok',
	packages: 'Csomagok',
	explorations: 'Böngészések',
	stories: 'Történetek',
	notebooks: 'Notebook dokumentumok',
	others: 'Egyéb',

	// Error Messages
	itemsOverLimit: 'A megadott "%{itemName}" név meghaladja a maximális korlátot (20). A folytatáshoz adjon meg másik nevet.',
	errorMessageLengthFolderName: 'Adjon meg olyan mappanevet, amely nem haladja meg a 255 karaktert.',
	errorMessageLengthLinkName: 'Adjon meg olyan hivatkozásnevet, amely nem haladja meg a 255 karaktert.',
	toastLaunchPerspectiveError: 'A(z) %{objectType} nem nyitható meg.',
	errorNoAccessTitle: 'Hmm, úgy tűnik, nem rendelkezik hozzáféréssel ehhez a tartalomhoz',
	errorNoAccessBody: 'Forduljon az adminisztrátorhoz, vagy tekintse meg a következő hivatkozást:',
	errorEnableExternalContent: 'Külső tartalom engedélyezése',

	//TableHeader
	lastModified: 'Utolsó módosítás',
	location: 'Hely',
	tenant: 'Bérlő',

	// GetStartedTab
	getStartedLabel: 'Az IBM Cognos Analytics használatának megkezdése',
	learningHowToLabel: 'Tanulási információforrások',
	learningHowToDescription: 'A csatlakozással a közösséghez, a dokumentáció olvasásával és a videók megtekintésével bővítheti a tudását és segítséget is kaphat.',
	learningHowToActionLabel: 'Tanulás panel indítása',
	howToVideosLabel: 'Tanácsadó videók',
	howToVideosDescription: 'Megismerkedhet az IBM Cognos Analytics használatával és betekintést nyerhet az adataiba.',
	howToVideosActionLabel: 'Videók megtekintése',
	acceleratorCatalogLabel: 'Gyorsító katalógus',
	acceleratorCatalogDescription: 'Böngéssze az iparági használat, követendő eljárásokat tartalmazó útmutatók, egyéni ábrázolások, stb. növekvő katalógusát.',
	acceleratorCatalogActionLabel: 'Katalógus böngészése',
	sampleSectionTitle: 'Minták',
	sampleSectionDescription: 'Kísérletezzen a példákkal, amelyek bemutatják, hogy a Cognos Analytics mi mindent tud nyújtani.',
	// Samples Section
	createDashboardSampleTitle: 'Az első műszerfal létrehozása',
	createDashboardSampleDescription: 'Kezdje meg elemzési útját a Cognos Dashboards alkalmazással.',
	covid19SampleTitle: 'COVID műszerfal',
	covid19SampleDescription: 'Fedezze fel a megvalósítható dolgok művészetét ezzel a COVID-19 járványhoz kapcsolódó adatokat elemző Cognos műszerfallal és az egyéni kiterjesztésekkel.',
	sankeySampleTitle: 'Sankey',
	sankeySampleDescription: 'Bővítse megjelenítési könyvtárát egyéni megjelenítésekkel, mint például a Sankey diagram.',
	viewAllSamplesActionLabel: 'Összes minta megtekintése',
	byFeatureTitle: 'Szolgáltatás szerint',
	byFeatureDescription: 'Minták tallózása szolgáltatás alapján, például alapműködés, egyéni vezérlők, bővítmények, munkafüzetek és relatív dátumok. ',
	byIndustryTitle: 'Iparág szerint',
	byIndustryDescription: 'Minták tallózása iparág alapján, például, autóipar, bankszektor, stb. ',
	// SamplesTab
	sampleTabTitle: 'Merítsen ötleteket a beépített mintákból',
	sampleTabLabel: 'Keresse fel az Accelerator katalógust további mintákért és bővítményeként az IBM, partnerei és vevői részéről. ',

	// quickLaunch
	quickLaunchLabel: 'Gyors indítás',
	expand: 'Kibontás',
	collapse: 'Visszazárás',

	// quickLaunch dialog
	quickLaunchModalLabel: 'Kezdje azzal, hogy kiválasztja, mit szeretne létrehozni.',

	// contentPageView
	contentPageTitleLabel: 'Tartalom',
	uploadFile: 'Adatok feltöltése',
	new: 'Új',
	create: 'Létrehozás',
	more: 'Továbbiak',

	// open dialog
	selectDataSourcesToAdd: 'Válassza ki a hozzáadandó adatforrás(oka)t.',
	openDialogDefaultTitle: 'Megnyitás',

	// save dialog
	save: 'Mentés',
	saveAs: 'Mentés másként',
	saving: 'Mentés...',
	selectedDestination: 'Kiválasztott cél: %{nameOfFolder}',
	toastDuplicateFileDifferentType: 'A(z) \'%{nameOfItem}\' eltérő típussal már létezik. Válasszon másik nevet.',
	confirmOverwriteTitle: 'A meglévő adatok cseréjének megerősítése',
	confirmOverwriteMsg: 'A(z) \'%{nameOfFile}\' fájl már létezik. Lecseréli az adatait a kijelölt fájlban található adatokra?',

	// copy move dialog
	copy: 'Másolás',
	move: 'Áthelyezés',
	copyOrMove: 'Másolás vagy áthelyezés: ',
	copyOnly: 'Másolás ',
	createShortcut: 'Parancsikon létrehozása',
	createShortcutDialogTitle: 'Parancsikon létrehozása: ',

	// External asset types
	wsProject: 'Watson Studio projekt',
	externalContentTypeWs: 'Watson Studio',

	// Asset Types
	package: 'Csomag',
	dataModule: 'Adatmodul',
	exploration: 'Böngészés',
	mode: 'Mód',
	live: 'Élő',
	snapshot: 'Pillanatkép',
	noSnapshotsFound: 'Nem található pillanatkép',
	uploadedFile: 'Feltöltött fájl',
	fileUpload: 'Adatok feltöltése',
	dataSetEx: 'Adathalmaz',
	externalRepository: 'Külső tár',
	queryMode: 'Lekérdezési mód',
	queryModeCompatible: 'Kompatibilis',
	queryModeDynamic: 'Dinamikus',
	report: 'Jelentés',
	activeReport: 'Aktív jelentés',
	query: 'Lekérdezés',
	analysis: 'Elemzés',
	dashboard: 'Műszerfal',
	dashboardTemplate: 'Műszerfal sablon',
	jupyterNotebook: 'Munkafüzet',
	wsNotebook: 'Watson Studio notebook',
	jupyter: 'Jupyter',
	ws: 'Watson Studio',
	story: 'Történet',
	workspace: 'Munkaterület',
	pagelet: 'Lap',
	content: 'Tartalom',
	directory: 'Névterek',
	dataSet: 'Adathalmaz',
	powerPlayCube: 'PowerPlay kocka',
	powerPlayReport: 'PowerPlay jelentés',
	powerPlay8Report: 'PowerPlay jelentés',
	powerPlay8ReportView: 'PowerPlay jelentés nézet',
	reportTemplate: 'Jelentéssablon',
	packageConfigurations: 'Csomagkonfiguráció',
	agent: 'Ügynök',
	agentDefinition: 'Ügynökdefiníció',
	agentDefinitionView: 'Ügynöknézet',
	dataMovementTask: 'Adatáthelyezési feladat',
	dataMovementTaskAlias: 'Adatáthelyezési feladat álneve',
	document: 'Dokumentum',
	DocumentRetention: 'Dokumentumtulajdonságok',
	jobDefinition: 'Munkameghatározás',
	job: 'Munka',
	metricsDataSourceETLTask: 'Metrika-adatforrás ETL-feladata',
	metricsExportTask: 'Metrikaexportálási feladat',
	metricsFileImportTask: 'Metrikafájl-importálási feladat',
	metricsMaintenanceTask: 'Metrika-karbantartási feladat',
	planningTask: 'Tervezési feladat',
	shortcut: 'Parancsikon',
	URL: 'URL-cím',
	launchable: 'Indítható',
	dataSetFolder: 'Adatkészletmappa',
	ViewAccessibleLabel: '%{label} megtekintése',
	overrideReportOptions: 'Alapértelmezett jelentésbeállítások felülbírálása',
	formats: 'Formátumok',
	saveReport: 'Jelentés mentése',
	promptForValues: 'Kérdezzen rá',
	reportView: 'Jelentésnézet',
	html: 'html',
	pdf: 'pdf',
	spreadsheetML: 'Excel',
	xlsxData: 'Excel-adatok',
	csv: 'csv',
	xml: 'xml',
	txt: 'txt',
	//Details
	details: 'Részletek',
	open: 'Megnyitás',
	created: 'Létrehozva',
	modified: 'Módosítva',
	owner: 'Tulajdonos',
	dataSource: 'Adatforrás',
	share: 'Megosztás',
	addToFavorites: 'Hozzáadás a kedvencekhez',
	properties: 'Tulajdonságok',
	detailsEmptyStateBody: 'Elem kiválasztása a részletek megtekintéséhez',
	editNameAndDescription: 'Név és leírás szerkesztése',
	none: 'Nincs',

	//rename dialog
	nameInvalid: 'A név érvénytelen',
	namePlaceholder: 'Név megadása',
	description: 'Leírás',
	descriptionInvalid: 'A leírás nem haladhatja meg a 350 karaktert. ',
	descriptionPlaceholder: 'Adjon meg egy leírást',
	errorMessageApostropheError: 'Olyan fájlnevet adjon meg, amely nem tartalmaz \'  és " karaktereket',
	renameCollisionError: 'A(z) %{name} már létezik. Adjon meg másik nevet.',
	unknownRenameError: 'Az elem átnevezése sikertelen volt. További segítségért forduljon az adminisztrátorhoz.',

	//types
	xls: 'xls',
	xlsx: 'xlsx',

	unableToOpenFolderMsg: 'A megadott mappa nem nyitható meg.',

	//Upload
	uploadToFolder: "Feltöltés ide: <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span>%{launchAction}",
	uploadAndLaunch: "Feltöltés a(z) <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> mappába és a(z) {launchAction} indítása",
	quickUpload: "Gyors feltöltés",
	quickUploadAndLaunch: "Húzzon át ide fájlokat a feltöltéshez a(z) <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> helyre és a megnyitáshoz a következő területek egyikében.",
	unsupportedFilesSingle: "A(z) %{files} feltöltése meghiúsult, mert Gyors indítás esetén érvénytelen.",
	unsupportedFilesMultiple: "A fájlok nem lettek feltöltve, mert a Gyors indítás használatához az összes kiválasztott fájlnak érvényesnek kell lennie.",
	unsupportedFilesSingleInvalid: "A(z) %{files} érvénytelen.",
	unsupportedFilesMultipleInvalid: "A(z) %{files} érvénytelen.",
	supportedFileTypes: "Csak a következő fájltípusok engedélyezettek: %{extensions}.",
	uploadDragAndDrop: "Áthúzás",
	uploadDragAndDropMessage: "Húzza át a fájlokat ide a feltöltésükhöz a(z) <span class=\"homeUploadFolder\">\"<span id=\"homeUploadFolderName\">%{folderName}</span>\"</span> helyre",

	// searchBar
	searchWasSaved: 'A(z) \'%{searchTerm}\' keresési feltétel mentésre került.',
	searchWasntSaved: 'A(z) \'%{searchTerm}\' keresési feltétel nem került mentésre.',
	searchSuggestions: 'Javaslatok',
	savedSearch: 'Mentett keresések',
	searchWasDeleted: 'A(z) \'%{searchTerm}\' keresési feltétel törlésre került.',
	searchWasntDeleted: 'A(z) \'%{searchTerm}\' keresési feltétel nem került törlésre.',
	savedBarTitle: 'Keresés a Cognos Analytics alkalmazásban',
	searchContentPageTitle: 'Keresés',
	searchContentPageTitleLabel: '\'%{searchTerm}\' eredményeinek megjelenítése',
	showingSearchRsult: '%{resultCount} elem megjelenítése',
	saveSearch: 'Keresés mentése',
	saveTenSearches: '10 keresést menthet.',
	deleteASearch: 'Újabb mentéséhez töröljön egy korábbit.',
	close: 'Bezárás',

	//recent view
	recents: 'Legutóbbi',
	noAccessRecent: 'Nincs hozzáférés',
	noAccessRecentMsg: 'Nem rendelkezik hozzáféréssel ehhez az eszközhöz. Lehet hogy tiltott vagy törölték, vagy csökkentették az engedélyeit. Ellenőrizze az eszköz állapotát a feltételezett forráshelyén. Az OK gombra kattintva eltávolíthatja az elemet az újkeletű elemek közül.',
	noAccessMsg: 'Nem rendelkezik hozzáféréssel ehhez az eszközhöz. Lehet hogy tiltott vagy törölték, vagy csökkentették az engedélyeit.',

	//contextToolbar
	itemsSelected: '%{nameOfSelection} elem kiválasztva',
	itemSelected: '%{nameOfSelection} elem kiválasztva'

});